import React, { useState, useEffect } from 'react';
import { MdWbSunny } from "react-icons/md";
import { FaMoon } from "react-icons/fa";

const ThemeToggle = () => {
  // Set the default to dark mode, and check localStorage for any preference
  const [isDarkMode, setIsDarkMode] = useState(() => {
    const savedTheme = localStorage.getItem('color-theme');
    if (savedTheme) {
      return savedTheme === 'dark';
    }
    // Default to dark mode if no preference is saved
    return true;
  });

  useEffect(() => {
    const root = document.documentElement;
    
    // Apply the theme when component mounts
    if (isDarkMode) {
      root.classList.add('dark');
      localStorage.setItem('color-theme', 'dark');
    } else {
      root.classList.remove('dark');
      localStorage.setItem('color-theme', 'light');
    }
  }, [isDarkMode]);

  const toggleTheme = () => {
    setIsDarkMode(prevMode => !prevMode);
  };

  return (
    <div className="">
      <button
        onClick={toggleTheme}
        className="flex items-center justify-center p-2 text-gray-500 rounded-lg hover:text-gray-900 hover:bg-gray-100 dark:text-gray-400 dark:hover:text-white dark:hover:bg-gray-700"
      >
        {isDarkMode ? (
          <MdWbSunny className="h-6 w-6" aria-hidden="true" />
        ) : (
          <FaMoon className="h-5 w-5" aria-hidden="true" />
        )}
      </button>
    </div>
  );
};

export default ThemeToggle;
